import React, { useState } from 'react';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import { Card, CardHeader } from '@mui/material';

function FormExample() {
  const [selectedTab, setSelectedTab] = useState(0);
  const [selectedSubTab, setSelectedSubTab] = useState(0);

  const handleTabChange = (event, newValue) => {
    setSelectedTab(newValue);
    // Reset the selectedSubTab when switching tabs
    setSelectedSubTab(0);
  };

  const handleSubTabChange = (event, newValue) => {
    setSelectedSubTab(newValue);
  };

  return (
    <div style={{ padding: '10px' }}>
      <Box className="form-container">
        <Tabs value={selectedTab} onChange={handleTabChange} aria-label="basic tabs example" className="tabs">
          <Tab label="Vehicle" className="tab" />
          <Tab label="Vehicle Search" className="tab" />
        </Tabs>
        {selectedTab === 0 && (
          <Card style={{ padding: '20px' }}>
             <h2>Vehicle Information</h2>
      <Box role="tabpanel" hidden={selectedTab !== 0} className="tabpanel">
        <Tabs value={selectedSubTab} onChange={handleSubTabChange} aria-label="sub tabs example" className="sub-tabs">
          <Tab label="Vehicle Details" className="sub-tab" />
          <Tab label="Vehicle Type Details" className="sub-tab" />
          <Tab label="Vehicle Example" className="sub-tab" />
          <Tab label="Vehicle Type Details" className="sub-tab" />
          <Tab label="Vehicle Details" className="sub-tab" />
          
          {/* Add other tabs here */}
        </Tabs>
        {/* Add form fields for Vehicle Details here */}
        {selectedSubTab === 0 && (
          <form className="form">
            <div style={{display:'flex', flexDirection:'row'}}>
                <div>
                    <TextField label="Make" fullWidth className="input"/>
                    <TextField label="Model" fullWidth className="input" />
                    {/* Add other fields */}
                </div>
                <div>
                    <TextField label="Make" fullWidth className="input" />
                    <TextField label="Model" fullWidth className="input" />
                    {/* Add other fields */}
                </div>
                <div>
                    <TextField label="Make" fullWidth className="input" />
                    <TextField label="Model" fullWidth className="input" />
                    {/* Add other fields */}
                </div>
            </div>
            <Button variant="contained" color="primary" className="submit-button">Submit</Button>
          </form>
        )}
        {/* Add form fields for Vehicle Type Details here */}
        {selectedSubTab === 1 && (
          <form className="form">
            <div style={{display:'flex', flexDirection:'row'}}>
                <div>
                    <TextField label="Make" fullWidth className="input" />
                    <TextField label="Model" fullWidth className="input" />
                    {/* Add other fields */}
                </div>
                <div>
                    <TextField label="Make" fullWidth className="input" />
                    <TextField label="Model" fullWidth className="input" />
                    {/* Add other fields */}
                </div>
                <div>
                    <TextField label="Make" fullWidth className="input" />

                    {/* Add other fields */}
                </div>
            </div>
            <Button variant="contained" color="primary" className="submit-button">Submit</Button>
          </form>
        )}
        {/* Add forms for other tabs here */}
        {selectedSubTab === 2 && (
          <form className="form">
            <div style={{display:'flex', flexDirection:'row'}}>
                <div>
                    <label>Label Example</label>
                    <input className='input-form-bar'/>
                    <label>Label Example</label>
                    <input className='input-form-bar'/>
                    {/* Add other fields */}
                </div>
                
            </div>
            <Button variant="contained" color="primary" className="submit-button">Submit</Button>
          </form>
        )}
        {/* 3 */}
        {selectedSubTab === 3 && (
          <form className="form">
            <div style={{display:'flex', flexDirection:'row'}}>
                <div>
                    <TextField label='example text' className='input-form-bar'/>
                    {/* Add other fields */}
                </div>
                
            </div>
            <Button variant="contained" color="primary" className="submit-button">Submit</Button>
          </form>
        )}
      </Box>
          </Card>
        )}
        {selectedTab === 1 && (
          <Card style={{ padding: '20px' }}>
            <form className="form">
              <TextField label="Search" fullWidth className="input" />
              {/* Add other fields */}
              <Button variant="contained" color="primary" className="submit-button">
                Search
              </Button>
            </form>
          </Card>
        )}
        {/* Add other tabs and their content here */}
      </Box>
    </div>
  );
}

export default FormExample;
